import { chainConfigs } from "../constants/chainConfigs";

export const getChainRPCsMap = () =>
  Object.fromEntries(
    chainConfigs.map(({ chainId, providers }) => [chainId, providers.rpc])
  );
